// extracted by mini-css-extract-plugin
module.exports = {"title":"ProductAllRows_title__3IcEJ"};